module.exports = __webpack_public_path__ + "img/en.e2166cbf.svg";